export default __webpack_public_path__ + "static/media/bi-top-new-logo-hub.d0e871c0.png";